// ── ASSET URL RESOLVER ──
function _a(name) {
  var n = name.replace(/^img\//, '');
  return (window._kaeroAssets && window._kaeroAssets[n]) || name;
}

// ── NAV ──
const nav = document.getElementById('nav');
addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 50));
const ham = document.getElementById('nav-ham');
const drawer = document.getElementById('nav-drawer');
ham.addEventListener('click', () => {
  const open = ham.classList.toggle('open');
  drawer.classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
});
document.querySelectorAll('.nav-d-link, .nd-cta').forEach(a => {
  a.addEventListener('click', () => {
    ham.classList.remove('open'); drawer.classList.remove('open');
    document.body.style.overflow = '';
  });
});

// ── REVEAL ──
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const t = e.target;
    if (t.classList.contains('pcard')) t.classList.add('in');
    else if (t.classList.contains('feat-item')) t.classList.add('in');
    else if (t.classList.contains('step')) t.classList.add('in');
    else t.classList.add('vis');
    io.unobserve(t);
  });
}, { threshold: .1 });
document.querySelectorAll('.rv,.rv-l,.rv-r,.pcard,.feat-item,.step').forEach(el => io.observe(el));

// ── STATS COUNT-UP ──
const sio = new IntersectionObserver(entries => {
  entries.forEach(x => {
    if (!x.isIntersecting) return;
    x.target.querySelectorAll('[data-t]').forEach(el => {
      const target = +el.dataset.t; let cur = 0;
      const step = target / (1200 / 16);
      const tm = setInterval(() => {
        cur += step;
        if (cur >= target) { el.textContent = target; clearInterval(tm); }
        else el.textContent = Math.floor(cur);
      }, 16);
    });
    sio.unobserve(x.target);
  });
}, { threshold: .5 });
sio.observe(document.getElementById('stats'));

// ── PRODUCT FILTERS ──
let activePack = '50';
let activeMm = 'all';

function formatPrice(val) {
  return '€' + parseFloat(val).toFixed(2).replace('.', ',');
}

function updatePriceDisplay() {
  document.querySelectorAll('.pcard').forEach(card => {
    const priceEl = card.querySelector('.p-price');
    const labelEl = card.querySelector('.p-price-label');
    if (!priceEl) return;
    let price, label;
    if (activePack === '50') {
      price = card.dataset.price50; label = '/ 50er Pack';
    } else if (activePack === '10') {
      price = card.dataset.price10; label = '/ 10er Pack';
    } else if (activePack === '20box') {
      price = card.dataset.price20box; label = '/ 20er Box';
    }
    if (price) priceEl.textContent = formatPrice(price);
    if (labelEl && label) labelEl.textContent = label;
  });
}

function applyFilters() {
  const allCards = document.querySelectorAll('.pcard');
  const newlyVisible = [];

  allCards.forEach(card => {
    const cardMm = card.dataset.mm || '';
    const show = activeMm === 'all' || cardMm.split(',').includes(activeMm);
    const wasHidden = card.style.display === 'none';
    if (show) {
      card.style.display = '';
      card.classList.remove('hidden');
      if (wasHidden) newlyVisible.push(card);
    } else {
      card.style.display = 'none';
      card.classList.add('hidden');
    }
  });

  // update filter count display
  document.querySelectorAll('.cv').forEach(el => {
    const val = activePack === '20box' ? (el.dataset['20box'] || '20×10') : (el.dataset[activePack] || '');
    el.textContent = val;
  });
  updatePriceDisplay();
  return newlyVisible;
}

function animateVisibleCards() {
  document.querySelectorAll('.pcard:not(.hidden)').forEach((c, i) => {
    c.classList.add('sa-hide');
    c.classList.remove('in');
    void c.offsetHeight;
    setTimeout(() => {
      c.classList.remove('sa-hide');
      c.classList.add('in');
    }, i * 80 + 16);
  });
}

function animateNewCards(cards) {
  cards.forEach((c, i) => {
    // sa-hide wins over is-visible!important (same specificity, later in CSS source)
    c.classList.add('sa-hide');
    c.classList.remove('in');
    void c.offsetHeight; // commit sa-hide before animation starts
    setTimeout(() => {
      c.classList.remove('sa-hide');
      c.classList.add('in'); // cardRise from{opacity:0} overrides is-visible!important
    }, i * 80 + 16);
  });
}

// Pack cards
document.querySelectorAll('.pack-card').forEach(btn => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.pack-card').forEach(b => b.classList.remove('on'));
    this.classList.add('on');
    activePack = this.dataset.v;
    // swap card photos (20box shows 10er image)
    document.querySelectorAll('.prod-photo').forEach(img => {
      const newSrc = activePack === '50' ? img.dataset.src50 : img.dataset.src10;
      if (!newSrc) return;
      const newZoom = activePack === '50' ? (img.dataset.zoom50 || '1') : (img.dataset.zoom10 || '1');
      img.style.setProperty('--bz', newZoom);
      img.style.opacity = '0';
      setTimeout(() => {
        img.src = newSrc;
        img.style.transition = 'opacity .4s';
        img.style.opacity = '1';
      }, 220);
    });
    applyFilters();
    animateVisibleCards();
  });
});

// mm pills (global filter)
document.querySelectorAll('.mm-pill').forEach(btn => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.mm-pill').forEach(b => b.classList.remove('on'));
    this.classList.add('on');
    activeMm = this.dataset.v;
    applyFilters();
    animateVisibleCards();
    // Auto-select the matching diameter chip in product cards
    if (activeMm !== 'all') {
      document.querySelectorAll('.pcard').forEach(card => {
        const cardMm = (card.dataset.mm || '').split(',');
        if (cardMm.includes(activeMm)) {
          const chip = card.querySelector('.p-mm-chip[data-mm-val="' + activeMm + '"]');
          if (chip && !chip.classList.contains('on')) chip.click();
        }
      });
    }
  });
});

// mm chips inside Blue card (diameter selector)
document.querySelectorAll('.p-mm-chip').forEach(chip => {
  chip.addEventListener('click', function () {
    const card = this.closest('.pcard');
    card.querySelectorAll('.p-mm-chip').forEach(c => c.classList.remove('on'));
    this.classList.add('on');
    const mmVal = this.dataset.mmVal;
    // update visual badge on card image
    const badge = card.querySelector('.p-mm-badge');
    if (badge) badge.textContent = mmVal + 'mm';
    // update diameter in specs row
    const specMm = card.querySelector('.p-spec-mm');
    if (specMm) specMm.textContent = mmVal + 'mm';
  });
});

// ── PRODUCT CARD TILT ──
document.querySelectorAll('.pcard').forEach(card => {
  card.addEventListener('mousemove', e => {
    const r = card.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - .5;
    const y = (e.clientY - r.top) / r.height - .5;
    card.style.transform = `translateY(-14px) rotateY(${x * 7}deg) rotateX(${-y * 5}deg)`;
  });
  card.addEventListener('mouseleave', () => card.style.transform = '');
});

// ── GALLERY ──
const galData = {
  blue:  {
    main:_a('img/lb-3.webp'),
    name:'Light Blue Edition',
    sub:'6/7/9mm · 10er & 50er Pack',
    thumbs:[]
  },
  green: {
    main:_a('img/gr-2.avif'),
    name:'Green Edition',
    sub:'9mm · 10er & 50er Pack',
    thumbs:[]
  },
  pink:  {
    main:_a('img/pink-render-c.avif'),
    imgContain: true,
    name:'Pink Edition',
    sub:'7mm · 10er & 50er Pack',
    thumbs:[]
  },
  black: {
    main:_a('img/ffm-combo.jpg'),
    imgContain: true, imgDark: true,
    name:'Black Frankfurt Edition',
    sub:'9mm · 10er & 50er Pack · Limitiert',
    thumbs:[]
  },
};
const galImg = document.querySelector('.gal-main-img');
const galMainEl = document.querySelector('.gal-main');
const galTitle = document.getElementById('gal-title');
const galSub = document.querySelector('.gal-cap-sub');
const galThumbsEl = document.getElementById('gal-thumbs');
let curGalScale = 1;

function setGalImg(src) {
  galImg.style.opacity = '0';
  galMainEl.style.setProperty('--gs', curGalScale * 0.97);
  setTimeout(() => {
    galImg.src = src;
    galImg.style.transition = 'opacity .3s, transform .4s cubic-bezier(.16,1,.3,1)';
    galImg.style.opacity = '1';
    galMainEl.style.setProperty('--gs', curGalScale);
  }, 200);
}
function buildThumbs(col) {
  galThumbsEl.innerHTML = '';
  galData[col].thumbs.forEach((t, i) => {
    const d = document.createElement('div');
    d.className = 'gal-thumb' + (i === 0 ? ' on' : '');
    d.dataset.c = t.c; d.dataset.src = t.src;
    d.innerHTML = `<img src="${t.src}" alt=""/>`;
    d.addEventListener('click', () => {
      galThumbsEl.querySelectorAll('.gal-thumb').forEach(x => x.classList.remove('on'));
      d.classList.add('on'); setGalImg(t.src);
    });
    galThumbsEl.appendChild(d);
  });
}
document.querySelectorAll('.gal-tab').forEach(tab => {
  tab.addEventListener('click', function () {
    document.querySelectorAll('.gal-tab').forEach(t => t.classList.remove('on'));
    this.classList.add('on');
    const col = this.dataset.col;
    curGalScale = galData[col].imgScale || 1;
    galMainEl.classList.toggle('gal-contain', !!galData[col].imgContain);
    galMainEl.classList.toggle('gal-dark', !!galData[col].imgDark);
    galTitle.textContent = galData[col].name;
    galSub.textContent = galData[col].sub;
    buildThumbs(col);

    /* Replay the full rocket animation for each tab switch */
    const galSec = document.getElementById('gallery');
    if (galSec && galSec.classList.contains('ks-gallery-on')) {
      galMainEl.style.setProperty('--gs', curGalScale);
      galSec.classList.remove('ks-gallery-on');
      galImg.src = galData[col].main;
      galImg.style.opacity = '1';
      galImg.style.transition = 'none';
      void galSec.offsetWidth; /* force reflow so CSS resets */
      galSec.classList.add('ks-gallery-on');
    } else {
      setGalImg(galData[col].main);
    }
  });
});
galThumbsEl.querySelectorAll('.gal-thumb').forEach(t => {
  t.addEventListener('click', function () {
    galThumbsEl.querySelectorAll('.gal-thumb').forEach(x => x.classList.remove('on'));
    this.classList.add('on'); setGalImg(this.dataset.src);
  });
});

// ── CONTACT FORM ──
// ── CONTACT FORM SUCCESS BANNER ──
// After native Shopify form submit, we return to /#contact?sent=1
// Show inline success banner and clean up the URL
if (new URLSearchParams(location.search).get('sent') === '1') {
  history.replaceState(null, '', location.pathname + '#contact');
  const form = document.getElementById('cf');
  if (form) {
    const banner = document.createElement('div');
    banner.style.cssText = 'background:#46B574;color:#fff;border-radius:10px;padding:16px 22px;font-size:15px;font-weight:600;margin-bottom:18px;text-align:center;';
    banner.textContent = '✓ Nachricht gesendet! Wir melden uns bald bei dir.';
    form.before(banner);
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

// ── EDITION CAROUSEL (removed) ──
(function(){
  const scroll = document.getElementById('edition-scroll');
  if (!scroll) return;

  const DURATION = 45; // seconds
  let trackWidth = 0, isDragging = false, currentX = 0;
  let dragStartClientX = 0, dragStartTX = 0;

  // Clone slides for seamless infinite loop
  const originals = Array.from(scroll.querySelectorAll('.edition-slide'));
  originals.forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    scroll.appendChild(clone);
  });

  // Measure original slide track width and set CSS var
  function setShift() {
    trackWidth = originals.reduce((sum, s) => sum + s.offsetWidth, 0);
    if (trackWidth > 0) scroll.style.setProperty('--edition-shift', `-${trackWidth}px`);
  }
  requestAnimationFrame(() => requestAnimationFrame(setShift));
  window.addEventListener('resize', setShift, { passive: true });

  // Read current translateX from the running animation
  function getCurrentX() {
    const m = getComputedStyle(scroll).transform;
    if (!m || m === 'none') return 0;
    const parts = m.match(/matrix.*\((.+)\)/)?.[1].split(', ');
    return parts ? parseFloat(parts[4]) : 0;
  }

  // Wrap x so it stays within [-trackWidth, 0]
  function normalizeX(x) {
    if (!trackWidth) return x;
    while (x < -trackWidth) x += trackWidth;
    while (x > 0) x -= trackWidth;
    return x;
  }

  // Freeze animation at current visual position
  function captureAndPause() {
    currentX = getCurrentX();
    scroll.style.animation = 'none';
    scroll.style.transform = `translateX(${currentX}px)`;
  }

  // Resume CSS animation from wherever we are now
  function resumeFrom(x) {
    x = normalizeX(x);
    if (!trackWidth) setShift();
    // negative delay = animation starts mid-cycle at the correct offset
    const delay = -((x / -trackWidth) * DURATION);
    scroll.style.transform = '';
    scroll.style.animation = `editionScroll ${DURATION}s linear ${delay}s infinite`;
  }

  // Hover: pause/resume (only when not dragging)
  const vp = scroll.closest('.edition-carousel-vp') || scroll.parentElement;
  vp.addEventListener('mouseenter', () => { if (!isDragging) scroll.style.animationPlayState = 'paused'; });
  vp.addEventListener('mouseleave', () => { if (!isDragging) scroll.style.animationPlayState = 'running'; });

  // ── Mouse drag ──
  scroll.addEventListener('mousedown', e => {
    isDragging = true;
    captureAndPause();
    dragStartClientX = e.clientX;
    dragStartTX = currentX;
    scroll.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    currentX = normalizeX(dragStartTX + (e.clientX - dragStartClientX));
    scroll.style.transform = `translateX(${currentX}px)`;
  });
  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    scroll.style.cursor = 'grab';
    resumeFrom(currentX);
  });

  // ── Touch swipe mit Momentum/Schwung ──
  let touchVX = 0, lastTouchX = 0, lastTouchTime = 0, momentumRAF = null;

  function cancelMomentum() {
    if (momentumRAF) { cancelAnimationFrame(momentumRAF); momentumRAF = null; }
  }

  scroll.addEventListener('touchstart', e => {
    cancelMomentum();
    captureAndPause();
    dragStartClientX = e.touches[0].clientX;
    dragStartTX = currentX;
    lastTouchX = e.touches[0].clientX;
    lastTouchTime = performance.now();
    touchVX = 0;
  }, { passive: true });

  scroll.addEventListener('touchmove', e => {
    const now = performance.now();
    const dt = now - lastTouchTime;
    if (dt > 0) touchVX = (e.touches[0].clientX - lastTouchX) / dt;
    lastTouchX = e.touches[0].clientX;
    lastTouchTime = now;
    currentX = normalizeX(dragStartTX + (e.touches[0].clientX - dragStartClientX));
    scroll.style.transform = `translateX(${currentX}px)`;
  }, { passive: true });

  scroll.addEventListener('touchend', () => {
    if (Math.abs(touchVX) < 0.05) { resumeFrom(currentX); return; }
    const FRICTION = 0.94;
    function step() {
      touchVX *= FRICTION;
      currentX = normalizeX(currentX + touchVX * 16);
      scroll.style.transform = `translateX(${currentX}px)`;
      if (Math.abs(touchVX) > 0.08) {
        momentumRAF = requestAnimationFrame(step);
      } else {
        resumeFrom(currentX);
      }
    }
    momentumRAF = requestAnimationFrame(step);
  });
})();

// ── SMOOTH SCROLL ──
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});

// ── PARALLAX (hero right image + orbs) ──
const heroRight = document.querySelector('.hero-right-img');
const heroOrbs  = document.querySelectorAll('.hero-orb');
addEventListener('scroll', () => {
  const y = scrollY;
  if (heroRight) heroRight.style.transform = `translateY(${y * 0.15}px)`;
  heroOrbs.forEach((o, i) => {
    o.style.transform = `translateY(${y * (0.06 + i * 0.03)}px)`;
  });
}, { passive: true });

// ── HERO CURSOR GLOW ──
const heroEl = document.getElementById('hero');
heroEl && heroEl.addEventListener('mousemove', e => {
  const r = heroEl.getBoundingClientRect();
  const x = ((e.clientX - r.left) / r.width  * 100).toFixed(2);
  const y = ((e.clientY - r.top)  / r.height * 100).toFixed(2);
  heroEl.style.setProperty('--mx', x + '%');
  heroEl.style.setProperty('--my', y + '%');
});
// inject cursor-glow pseudo overlay
const heroStyle = document.createElement('style');
heroStyle.textContent = `
  #hero::after{
    content:'';position:absolute;inset:0;z-index:1;pointer-events:none;
    background:radial-gradient(400px circle at var(--mx,50%) var(--my,50%),rgba(96,165,250,.07),transparent 60%);
  }
`;
document.head.appendChild(heroStyle);

// ── MAGNETIC BUTTONS ──
document.querySelectorAll('.btn-primary,.btn-ghost,.nav-cta,.p-cta,.fsub').forEach(btn => {
  btn.addEventListener('mousemove', e => {
    const r = btn.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width  - .5) * 12;
    const y = ((e.clientY - r.top)  / r.height - .5) * 12;
    btn.style.transform = `translate(${x}px,${y}px) translateY(-2px)`;
  });
  btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
});

// ── STICKER PARALLAX ──
document.querySelectorAll('.sticker-float').forEach((s, i) => {
  addEventListener('scroll', () => {
    const factor = i % 2 === 0 ? -0.12 : 0.09;
    s.style.marginTop = (scrollY * factor) + 'px';
  }, { passive: true });
});

// ── WARENKORB (Shopify AJAX Cart API) ──
function formatEur(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

// Fallback-Produktbild, falls die Shopify-Variante kein eigenes Bild hat.
// Wählt – wie auf der Homepage – passend zu Farbe UND Packgröße.
function cartItemImg(item) {
  var pt = ((item.product_title || '') + ' ' + (item.title || '')).toLowerCase();
  var vt = (item.variant_title || '').toLowerCase();
  var s  = pt + ' ' + vt;

  // ── Rolling Papers ──
  if (s.indexOf('rolling') !== -1 || s.indexOf('paper') !== -1) {
    if (s.indexOf('50') !== -1 || s.indexOf('box') !== -1) return _a('rp-50er-box.webp');
    return _a('rp-single.webp');
  }

  // ── Filter-Editionen: Farbe bestimmen ──
  var color = 'lb';
  if      (s.indexOf('green') !== -1 || s.indexOf('grün') !== -1) color = 'green';
  else if (s.indexOf('pink') !== -1)                              color = 'pink';
  else if (s.indexOf('frankfurt') !== -1 || s.indexOf('black') !== -1 || s.indexOf('schwarz') !== -1) color = 'ffm';
  else                                                            color = 'lb'; // Light Blue (Default)

  // ── Packgröße bestimmen ──
  var pack = '50';
  if      (s.indexOf('500') !== -1 || s.indexOf('zehner') !== -1 || s.indexOf('10×50') !== -1 || s.indexOf('10x50') !== -1 || s.indexOf('bag') !== -1) pack = 'bag';
  else if (s.indexOf('20er') !== -1 || s.indexOf('20×') !== -1 || s.indexOf('20x') !== -1 || s.indexOf('200') !== -1) pack = '20box';
  else if (s.indexOf('10er') !== -1 || s.indexOf('probier') !== -1) pack = '10';
  else pack = '50';

  // ── Bildmatrix (Farbe × Packgröße) – identisch zur Homepage ──
  var MAP = {
    lb:    { '50': 'lb-50er-pack.jpg',    '10': 'lb-10-desk.jpg',    '20box': 'lb-box-20.webp',   'bag': 'lb-bag-50.webp'   },
    green: { '50': 'green-render-a.avif', '10': 'green-10-desk.jpg', '20box': 'green-box-20.webp','bag': 'green-bag-50.webp' },
    pink:  { '50': 'pk-card.avif',        '10': 'pk-10-desk.jpg',    '20box': 'pink-box-20.webp', 'bag': 'pink-bag-50.webp' },
    ffm:   { '50': 'bfe-card.jpg',        '10': 'bfe-10-desk.jpg',   '20box': 'ffm-box-20.webp',  'bag': 'ffm-bag-50.webp'  }
  };

  // Für Box- und Bag-Formate immer das passende Box-/Bag-Foto erzwingen –
  // die Shopify-Variante hat hier kein korrektes Box-/Bag-Bild hinterlegt.
  if (pack === '20box' || pack === 'bag') return _a(MAP[color][pack]);

  // Sonst (50er/10er): vorhandenes Shopify-Variantenbild bevorzugen, sonst Matrix.
  if (item.image) return item.image;
  return _a(MAP[color][pack]);
}

async function fetchCart() {
  // cache:'no-store' -> immer den aktuellen Warenkorb laden.
  // Ohne das liefert der Browser (v.a. Desktop) ein gecachtes /cart.js,
  // wodurch die Artikel-Anzahl am Cart-Button verzögert/zu niedrig war.
  const r = await fetch('/cart.js', { cache: 'no-store' });
  return r.json();
}

async function updateCartCount() {
  try {
    const cart = await fetchCart();
    const total = cart.item_count || 0;
    const badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = total;
    badge.classList.toggle('show', total > 0);
  } catch(e) {}
}

async function renderCart() {
  const el = document.getElementById('cart-items');
  const foot = document.getElementById('cart-foot');
  const clearBtn = document.getElementById('cart-clear');
  if (!el) return;

  let cart;
  try { cart = await fetchCart(); } catch(e) { return; }

  if (!cart.items || cart.items.length === 0) {
    el.innerHTML = '<div class="cart-empty-wrap"><div class="cart-empty-icon">🛒</div><p class="cart-empty-txt">Dein Warenkorb ist leer.<br>Füge eine Edition hinzu!</p></div>';
    if (foot) foot.style.display = 'none';
    if (clearBtn) clearBtn.style.display = 'none';
    return;
  }
  if (foot) foot.style.display = '';
  if (clearBtn) clearBtn.style.display = '';

  el.innerHTML = cart.items.map((item) => `
    <div class="cart-item" data-key="${item.key}" data-variant="${item.variant_id}">
      <img class="cart-item-img" src="${cartItemImg(item)}" alt="${item.title}" loading="lazy"/>
      <div class="cart-item-body">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-sub">${item.variant_title || ''}</div>
        <div class="cart-item-row">
          <div class="cart-qty">
            <button class="qty-btn" data-action="dec" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="qty-val">${item.quantity}</span>
            <button class="qty-btn" data-action="inc" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
          <span class="cart-item-price">${formatEur(item.final_line_price)}</span>
        </div>
      </div>
      <button class="cart-item-del" data-key="${item.key}" title="Entfernen">×</button>
    </div>
  `).join('');

  const totEl = document.getElementById('cart-total');
  if (totEl) totEl.textContent = formatEur(cart.total_price);

  el.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const cur = +btn.dataset.qty;
      const newQty = btn.dataset.action === 'inc' ? cur + 1 : Math.max(0, cur - 1);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      await updateCartCount();
      await renderCart();
    });
  });

  el.querySelectorAll('.cart-item-del').forEach(btn => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      });
      await updateCartCount();
      await renderCart();
    });
  });
}

function openCart() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

document.getElementById('nav-cart')?.addEventListener('click', openCart);
document.getElementById('cart-close')?.addEventListener('click', closeCart);
document.getElementById('cart-overlay')?.addEventListener('click', closeCart);
document.getElementById('cart-checkout')?.addEventListener('click', () => {
  window.location.href = '/checkout';
});
document.getElementById('cart-clear')?.addEventListener('click', async (e) => {
  const btn = e.currentTarget;
  btn.disabled = true;
  const orig = btn.textContent;
  btn.textContent = '…';
  try {
    await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
    await updateCartCount();
    await renderCart();
  } catch(ex) { console.error('Cart clear Fehler:', ex); }
  btn.textContent = orig;
  btn.disabled = false;
});

// ATC via event delegation — works on originals AND carousel clones
const _svgCart = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
const _atcLabel = _svgCart + ' In den Warenkorb';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.atc-btn');
  if (!btn || btn.disabled) return;
  const card = btn.closest('.pcard');
  if (!card) return;

  const pack = activePack || '50';
  let variantId;

  if (card.dataset.hasMm === '1') {
    const activeChip = card.querySelector('.p-mm-chip.on');
    const mmKey = 'm' + (activeChip ? activeChip.dataset.mmVal : '7');
    if (pack === '50') {
      try { variantId = JSON.parse(card.dataset['vidsPack-50'])[mmKey]; } catch(ex) {}
    } else if (pack === '10') {
      try { variantId = JSON.parse(card.dataset['vidsPack-10'])[mmKey]; } catch(ex) {}
    } else {
      variantId = card.dataset.vid20box;
    }
  } else {
    if (pack === '50')      variantId = card.dataset.vid50;
    else if (pack === '10') variantId = card.dataset.vid10;
    else                    variantId = card.dataset.vid20box;
  }

  if (!variantId) {
    btn.textContent = 'Bald verfügbar';
    setTimeout(() => { btn.innerHTML = _atcLabel; }, 2000);
    return;
  }

  // Sofortiges visuelles Feedback – Button bleibt klickbar
  btn.innerHTML = '✓ Hinzugefügt';

  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });

    if (r.ok) {
      // Sofort öffnen + parallel zählen – kein doppelter Fetch
      openCart();
      updateCartCount();
      setTimeout(() => { btn.innerHTML = _atcLabel; }, 800);
    } else {
      const errData = await r.json().catch(() => ({}));
      console.error('ATC abgelehnt:', r.status, errData);
      const msg = errData.description || errData.message || 'Nicht verfügbar';
      btn.innerHTML = msg.length > 40 ? 'Nicht verfügbar' : msg;
      setTimeout(() => { btn.innerHTML = _atcLabel; }, 2600);
    }
  } catch(ex) {
    console.error('ATC Fehler:', ex);
    btn.innerHTML = _atcLabel;
  }
});

updateCartCount();
updatePriceDisplay();

